import { ChangeDetectionStrategy, Component, inject } from '@angular/core'

import { FlxThemeColorService } from '../color.service'

@Component({
  selector: 'flx-theme-colors-renderer',
  templateUrl: './theme-colors-renderer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./theme-colors-renderer.component.scss'],
})
export class FlxThemeColorsRendererComponent {
  readonly colors = inject(FlxThemeColorService).renderData
}
